import accounts from "./accounts";
import positions from "./positions";

const subscriptions = { ...positions, ...accounts };

export default subscriptions;
